import { defineComponent as _defineComponent } from 'vue'
import { userTargetsService } from '@/services/userTargets.service';
import { Customer } from '@/models/tenant';
import { UserTarget } from '@/models/userTarget';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { TargetsMetric } from '@/models/enums/TargetsMetric';
import { isNil } from '@/utils/misc';
import TableActionButton from '@/components/tableWithActions/TableActionButton.vue';
import TableWithActions from '@/components/tableWithActions/TableWithActions.vue';
import { dialogService } from '@/library-services/dialog.service';
import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import { useI18n } from '@/composables/i18n';
import { modalService } from '@/library-services/modal.service';
import TargetFormModal from './TargetFormModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Targets',
  props: {
    console: null,
    tenant: null
  },
  setup(__props: any) {

const props = __props as {
  console: ConsoleEnum;
  tenant: Customer;
};



const { t } = useI18n();
const app = getCurrentInstance();

const userTargets = ref<UserTarget[]>([]);
const isLoading = ref(false);

onMounted(async () => {
  await getTargets();
});

async function getTargets() {
  isLoading.value = true;
  try {
    await userTargetsService.getForTenant(props.tenant.id);
    userTargets.value = userTargetsService.store.getConsoleUserTargets(
      props.console,
    );
  } finally {
    isLoading.value = false;
  }
}

function createNewTarget() {
  modalService.compositionApi.open(
    {
      component: TargetFormModal,
      props: {
        console: props.console,
        customer: props.tenant,
      },
      events: {
        save: () => getTargets(),
      },
    },
    app,
  );
}

function confirmDelete(target: UserTarget): void {
  const translatedTargetMetric = t(
    `target.targetMetric.${target.targetMetric}`,
  );
  const message = !isNil(target.target2)
    ? translatedTargetMetric +
      ' (' +
      target.target1 +
      ', ' +
      target.target2 +
      ')'
    : translatedTargetMetric + ' (' + target.target1 + ')';

  dialogService.confirmWithPromise({
    title: t('dialog.confirm_title').toString(),
    message: t('action.delete').toString() + ` <b> ${message} </b>?`,
    confirmText: t('dialog.confirm_delete').toString(),
    cancelText: t(`dialog.confirm_cancel`).toString(),
    type: 'is-danger',
    onConfirm: async () => await deleteTarget(target.id!),
  });
}

async function deleteTarget(userTargetId: number) {
  await userTargetsService.delete(userTargetId).then(() => {
    userTargets.value = userTargets.value.filter(
      (userTarget) => userTarget.id !== userTargetId,
    );
  });
}

async function editTarget(userTarget: UserTarget) {
  modalService.compositionApi.open(
    {
      component: TargetFormModal,
      props: {
        console: props.console,
        customer: props.tenant,
        userTarget,
      },
      events: {
        save: () => getTargets(),
      },
    },
    app,
  );
}

function translateMetric(targetMetric: TargetsMetric) {
  return t(`target.targetMetric.${targetMetric}`);
}

const consoleName = computed(() =>
  t(`category_menu.${ConsoleEnum[props.console]}`),
);

return { __sfc: true,props, t, app, userTargets, isLoading, getTargets, createNewTarget, confirmDelete, deleteTarget, editTarget, translateMetric, consoleName, TableActionButton, TableWithActions }
}

})